import React, { useState } from 'react';
import ScrollReveal from '../ui/ScrollReveal';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Portfolio = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Work' },
    { id: 'websites', name: 'Websites' },
    { id: 'branding', name: 'Branding' },
    { id: 'photography', name: 'Photography' }
  ];

  const projects = [
    {
      id: 1,
      title: 'The Vladimir Collection',
      category: ['websites', 'branding'],
      image: 'https://app.milanote.com/media/p/images/1TZl4J1uaXLgcv/VFq/combined_screenshots_with_drawing%20%288%29.jpg',
      description: 'Luxury real estate website design'
    },
    {
      id: 2,
      title: 'Pinnacle Roofing',
      category: ['websites', 'branding', 'logo'],
      image: 'https://app.milanote.com/media/p/images/1TZl4J1uaXLgcw/HWE/combined_screenshots_with_drawing%20%289%29.jpg',
      description: 'Full brand identity and website redesign'
    },
    {
      id: 3,
      title: 'H.A. May Construction',
      category: ['websites', 'photography'],
      image: 'https://app.milanote.com/media/p/images/1TZlHu1uaXLgcx/1pk/combined_screenshots_with_drawing%20%2810%29.jpg',
      description: 'Construction company brand refresh and website'
    },
    {
      id: 4,
      title: 'Cagley Homes',
      category: ['websites', 'photography'],
      image: 'https://app.milanote.com/media/p/images/1TZlJA1uaXLgcy/OP8/combined_screenshots_with_drawing%20%2811%29.jpg',
      description: 'Website Rebuild, Website Hosting and Management, Photography'
    }
  ];

  const filteredProjects = activeCategory === 'all' 
    ? projects 
    : projects.filter(project => project.category.includes(activeCategory));

  return (
    <section className="section-padding bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <span className="inline-block px-3 py-1 bg-astrem-gray-100 text-astrem-gray-800 rounded-full text-sm font-medium mb-4">
            Our Portfolio
          </span>
        </ScrollReveal>
        
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12">
          <div>
            <ScrollReveal delay={100}>
              <h2 className="section-title mb-4">Featured Projects</h2>
            </ScrollReveal>
            
            <ScrollReveal delay={200}>
              <p className="text-lg text-astrem-gray-600 max-w-2xl">
                Explore our recent work for clients across different industries.
              </p>
            </ScrollReveal>
          </div>
          
          <ScrollReveal delay={300} className="mt-6 md:mt-0">
            <div className="flex flex-wrap gap-2">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setActiveCategory(category.id)}
                  className={`px-4 py-2 rounded-full text-sm transition-all ${
                    activeCategory === category.id
                      ? 'bg-astrem-black text-white'
                      : 'bg-astrem-gray-100 text-astrem-gray-700 hover:bg-astrem-gray-200'
                  }`}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </ScrollReveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {filteredProjects.map((project, index) => (
            <ScrollReveal key={project.id} delay={400 + (index * 100)}>
              <div className="group relative overflow-hidden rounded-xl bg-white/10 backdrop-blur-md border border-white/20 shadow-lg">
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-80"></div>
                <div className="absolute bottom-0 left-0 p-6 md:p-8">
                  <span className="text-xs text-white/80 uppercase tracking-wider">
                    {project.category.join(' • ')}
                  </span>
                  <h3 className="text-xl md:text-2xl font-medium text-white mt-2">
                    {project.title}
                  </h3>
                  <p className="text-white/90 mt-2">
                    {project.description}
                  </p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>

        <ScrollReveal delay={800} className="mt-12 text-center">
          <Button asChild className="bg-astrem-black hover:bg-astrem-gray-800 text-white rounded-full px-6">
            <Link to="/portfolio">
              View All Projects
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default Portfolio;
